import {Suspense, useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import './scss/style.scss';
import './App.css'
import AuthRouter from './navigation/AuthRouter';
import {useColorModes} from '@coreui/react';
import {QueryClientProvider} from 'react-query';
import {queryClient} from './utils/ReactQueryConfig';
import {ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const {setColorMode} = useColorModes('coreui-free-react-admin-template-theme')

  useEffect(() => {
    setColorMode('light')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Suspense
        // fallback={
        //   <div className="pt-3 text-center">
        //     <CSpinner color="primary" variant="grow" />
        //   </div>
        // }
        >
          <AuthRouter />
        </Suspense>
      </BrowserRouter>
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
